import { createFileRoute } from "@tanstack/react-router";
import { IncidentsScreen } from "./-incidents/IncidentsScreen";

export const Route = createFileRoute("/admin/incidents")({
  staticData: { title: "Incidents" },
  validateSearch: (s: Record<string, unknown>): { incident?: string } => (typeof s.incident === "string" && s.incident ? { incident: s.incident } : {}),
  component: IncidentsScreen,
});
